import type { CustomerDto } from "../api/customers-api";
import { formatMoney } from "./invoice-mappers";

const FLAG_BY_COUNTRY: Record<string, string> = {
  USA: "us.png",
  "United States": "us.png",
  Canada: "ca.png",
  UK: "gb.png",
  "United Kingdom": "gb.png",
  Germany: "de.png",
  France: "fr.png",
  Switzerland: "ch.png",
  India: "in.png",
};

function countryFlag(country: string | null) {
  if (!country) return "us.png";
  return FLAG_BY_COUNTRY[country] ?? "us.png";
}

export function customerToTableRow(c: CustomerDto, index: number, invoiceCount = 0) {
  return {
    key: c.id,
    id: c.id,
    rowId: c.id,
    img: `avatar-${(index % 28) + 1}.jpg`,
    flag_img: countryFlag(c.country),
    Customer: c.displayName,
    Phone: c.phone ?? "—",
    Country: c.country ?? "—",
    Balance: formatMoney(c.balance, c.currency),
    Total_Invoice: String(invoiceCount),
    Created_On: new Date(c.createdAt).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }),
    Status: c.status === "ACTIVE" ? "Active" : "Inactive",
  };
}
